import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import R from "ramda";

import AuthRepository from "repositories/AuthRepository";
import localStorage, { LOCAL_STORAGE_AUTH_KEY } from "utils/localStorage";
import emberLoginSync from "utils/emberLoginSync";
import selectedCastNumber from "utils/selectedCastNumber";
import { appRoutes } from "routes";

export const defaultAuth = {
  accessToken: null,
  createdAt: null,
  expiresIn: null,
  refreshToken: null,
  tokenType: null,
};

export const getAuthFromLocalStorage = () => {
  let storage = localStorage.getItem(LOCAL_STORAGE_AUTH_KEY);

  if (R.is(String, storage)) {
    storage = null;
  }

  if (storage) {
    return storage.auth;
  }

  const emberAuthData = emberLoginSync.getAuthInfo();
  if (emberAuthData) {
    localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, { auth: { ...emberAuthData } });
    return emberAuthData;
  }

  return defaultAuth;
};

const initialState = {
  auth: getAuthFromLocalStorage(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    getAuth(state, { payload }) {
      state.auth = payload;
    },
    resetAuth(state) {
      state.auth = {};
    },
  },
});

export const { actions } = authSlice;
export default authSlice.reducer;

export const useAuthActions = () => {
  const dispatch = useDispatch();

  const signIn = (attrs) => {
    return AuthRepository.getToken(attrs, { separator: "_" }).then(({ data }) => {
      dispatch(authSlice.actions.getAuth(data));
      localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, { auth: { ...data } });
      emberLoginSync.setAuthInfo(data);
      return Promise.resolve();
    });
  };

  const signOut = () => {
    const auth = getAuthFromLocalStorage();
    const attrs = { token: auth.accessToken };

    AuthRepository.revokeToken(attrs).then(() => {
      dispatch(authSlice.actions.resetAuth());
      localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY);
      emberLoginSync.logOut();
      localStorage.removeItem("castingData");
      selectedCastNumber.clear();
      window.location.href = appRoutes.rootPath();
    });
  };

  return {
    signIn,
    signOut,
  };
};
